import { render, staticRenderFns } from "./waliClassroomList.vue?vue&type=template&id=46cb5bfe&scoped=true&"
import script from "./waliClassroomList.vue?vue&type=script&lang=js&"
export * from "./waliClassroomList.vue?vue&type=script&lang=js&"
import style0 from "./waliClassroomList.vue?vue&type=style&index=0&id=46cb5bfe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cb5bfe",
  null
  
)

export default component.exports